

































































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import AuthModule from '@/store/modules/Auth';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import ProviderBody from '@/components/Table/ProviderBody.vue';
import GameReportBody from '@/components/Table/GameReportBody.vue';
import GameReportTypeBody from '@/components/Table/GameReportTypeBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import WinLoseData from '@/data/WinLoseData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ProductDropdown from '@/components/ProductDropdown.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    ProviderBody,
    LogBody,
    ProductDropdown,
    GameReportBody,
    GameReportTypeBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  componentKey = 0;

  Criteria = {
    ...this.Period,
    generic: true,
    isSearch: false,
    limit: 100,
    page: 1,
    provider: '',
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    providerType: '',
    game: '',
    isProviderReport: false,
    breadcrumb: [],
  };

  BreadcrumbList: any = [];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  BreadcrumbDefault = [
    {
      username: 'amb',
      value: '',
    },
  ];

  type = '';

  resultData: any = [];

  LoginName = '';

  TableHeadProvider = [...WinLoseData.TableHeadProvider];

  providerName = '';

  dropdownCriteria = {
    products: {
      type: 'Products',
      componentKeys: 0,
      selected: '',
    },
    categories: {
      type: 'Categories',
      componentKeys: 0,
      selected: '',
    },
    games: {
      type: 'Games',
      componentKeys: 0,
      selected: '',
      gamesList: [],
      sortList: [],
    },
  }

  isShow = {
    category: false,
    game: false,
  }

  currentReport = '';

  currnetProvider = '';

  currentType = '';

  isFetchProvider = true;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('$route.name', { immediate: true, deep: true })
  onChangeReport(val) {
    this.currentReport = val;
    this.initial();
    this.fetchProvider();
    this.fetchGame();
  }

  created() {
    // this.initial();
    this.fetchProvider();
    this.fetchGame();
  }

  async fetchGame() {
    const res = await this.GameInstance.FetchGame();
    if (res.code) {
      this.checkError(res);
    } else {
      await this.mapGameInput();
    }
  }

  async mapGameInput() {
    const games = await this.GameInstance.game;
    Object.keys(games).forEach((key) => {
      this.dropdownCriteria[key][`${key}List`] = games[key];
    });
  }

  handleProductDropdown(item, type) {
    if (type === 'Products') this.dropdownCriteria.products.selected = item.provider.toUpperCase();
    else this.dropdownCriteria[type.toLowerCase()].selected = item.value.toUpperCase();
    if (type === 'Products') {
      this.isShow.category = true;
      if (item.value === 'total') {
        this.isShow.category = false;
        this.isShow.game = false;
        this.dropdownCriteria.categories.selected = '';
        this.dropdownCriteria.games.selected = '';
        this.Criteria.provider = '';
      } else {
        this.dropdownCriteria.games.sortList = this.dropdownCriteria.games.gamesList
          .filter((v: any) => v.partner === item.value);
        this.Criteria.provider = item.value.toLowerCase();
      }
      this.isShow.game = false;
      this.isFetchProvider = true;
      this.dropdownCriteria.categories.selected = 'TOTAL';
      this.Criteria.providerType = '';
      // this.Criteria.gameName = 'TOTAL';
    }
    if (type === 'Categories') {
      this.isShow.game = true;
      if (item.value === 'total') {
        this.isShow.game = false;
        this.Criteria.providerType = '';
        this.isFetchProvider = true;
      } else {
        this.dropdownCriteria.games.sortList = this.dropdownCriteria.games.gamesList
          .filter((v: any) => v.partner.toUpperCase() === this.dropdownCriteria.products.selected
            && v.type === item.value)
          .sort((a: any, b: any) => a.game.localeCompare(b.game));
        this.isFetchProvider = false;
        this.Criteria.providerType = item.value;
      }
      this.dropdownCriteria.games.selected = '';
      // this.Criteria.gameName = 'TOTAL';
    }
    if (type === 'Games') this.Criteria.game = item.name;
    this.dropdownCriteria[type.toLowerCase()].componentKeys += 1;
    this.fetchProvider();
  }

  async fetchProvider() {
    this.GeneralInstance.toggleLoading(true);

    this.Criteria.isProviderReport = this.currentReport !== 'GameReport';

    const criteria = { ...this.Criteria, ...this.Period };

    this.resultData = this.isFetchProvider
      ? await this.ReportInstance.FetchProviderReport(criteria)
      : await this.ReportInstance.FetchProviderReportByType(criteria);

    this.BreadcrumbList = this.resultData.breadcrumb || this.BreadcrumbList;
    this.Criteria.breadcrumb = this.resultData.breadcrumb || this.resultData.breadcrumb;
    this.currnetProvider = this.Criteria.provider;
    this.currentType = this.Criteria.providerType;

    if (this.resultData.code) this.checkError(this.resultData.code);
    if (this.Criteria.provider && this.Criteria.provider !== 'amb' && !this.Criteria.isProviderReport) {
      const menuList = this.isFetchProvider
        ? ['report.winloseSimple.datatable.whiteLabel', 'report.winloseSimple.datatable.gameName']
        : ['report.winloseSimple.datatable.whiteLabel', 'report.winloseSimple.datatable.provider'];
      this.TableHeadProvider = [
        WinLoseData.TableHeadProvider[0].filter((v) => ![...menuList].includes(v.displayName)),
      ];
      this.providerName = this.Criteria.provider;
    } else {
      let header = WinLoseData.TableHeadProvider[0].filter((v) => v.displayName !== 'report.winloseSimple.datatable.gameType');
      if (this.Criteria.provider === 'amb') {
        header = WinLoseData.TableHeadProvider[0]
          .filter((v) => ![
            'report.winloseSimple.datatable.gameType',
            'report.winloseSimple.datatable.whiteLabel',
            'report.winloseSimple.datatable.gameName',
          ].includes(v.displayName));
      } else {
        header = WinLoseData.TableHeadProvider[0]
          .filter((v) => ![
            'report.winloseSimple.datatable.gameType',
            'report.winloseSimple.datatable.provider',
            'report.winloseSimple.datatable.gameName',
          ].includes(v.displayName));
      }
      this.TableHeadProvider = [header];
    }
    this.componentKey += 1;
    this.GeneralInstance.toggleLoading(false);
  }

  initial() {
    this.isFetchProvider = true;
    this.currentTool = 'Today';
    this.Period = {
      start: {
        date: this.$moment().startOf('day').toDate(),
      },
      end: {
        date: this.$moment().endOf('day').toDate(),
      },
    };
    this.Criteria = {
      ...this.Period,
      generic: true,
      isSearch: false,
      limit: 100,
      page: 1,
      provider: '',
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      providerType: '',
      game: '',
      isProviderReport: false,
      breadcrumb: [],
    };
    this.LoginName = '';
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    this.fetchProvider();
  }

  onSubmit() {
    this.fetchProvider();
  }

  handleSearch() {
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
  }

  handleFetchReportProvider(providerName) {
    this.beforeFetch(providerName);
  }

  handleFetchReportProviderByType(providerName, type) {
    this.isFetchProvider = false;
    this.Criteria.providerType = type;
    this.beforeFetch(providerName);
  }

  handleBreadcrumb({ value, username }) {
    if (username === this.currentType) this.isFetchProvider = false;
    else if (!value || value === this.currnetProvider) this.isFetchProvider = true;
    else this.isFetchProvider = false;
    this.beforeFetch(value);
  }

  beforeFetch(providerName) {
    this.PaginationDetail.current = 1;
    this.Criteria.provider = providerName;
    this.Criteria.page = 1;
    this.fetchProvider();
  }
}
